<div class="download">
  <div class="download__content">
    <div class="download__content__spinner">
      <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
      <span class="sr-only">Loading...</span>
    </div>
    <div class="download__content__message">
      <span>{{'components.requestDownloadComponent.messageDownload' | translate}}</span>
    </div>
  </div>
</div>
